module.exports = __webpack_public_path__ + "static/media/arrowRigth.bc7d802c.svg";